import { useState } from 'react';
export const useHeaderMenu = () => {
    const [parentPositionY, setParentPositionY] = useState(0);
    const updateParentPositionY = (y) => {
        setParentPositionY(y);
    };
    return { parentPositionY, updateParentPositionY };
};
useHeaderMenu.displayName = 'useHeaderMenu';
